/** Puní opisi Valladolid putovanja – HR / EN / DE / ES */

const VALLADOLID_KEYS = [
  "valladolid-1tjedan",
  "valladolid-2tjedan",
  "valladolid-1tjedan-lipanj",
  "valladolid-2tjedan-lipanj",
];

export const VALLADOLID_TOUR_DETAILED_INFO = {
  "valladolid-1tjedan": {
    hr: `VALLADOLID – UČENJE ŠPANJOLSKOG JEZIKA
Intenzivni tečaj jezika, kulture i autentične španjolske atmosfere

🗓 22.08. – 30.08.2026. | 9 dana / 8 noći

Putovanje je namijenjeno svima koji žele učiti ili usavršiti španjolski u autentičnom okruženju. Program kombinira intenzivni tečaj u Valladolidu, upoznavanje španjolske kulture i gastronomije te izlete u povijesne gradove Castille i Leóna. Tijekom putovanja sudionicima je na raspolaganju voditelj na hrvatskom i španjolskom jeziku.

📍 PROGRAM PUTOVANJA

1. DAN – 22.08. ZAGREB – MADRID
Sastanak putnika u poslijepodnevnim satima u zračnoj luci Franjo Tuđman. Direktan let Zagreb – Madrid u večernjim satima. Dolazak u kasnim večernjim satima, transfer do smještaja i noćenje u Madridu (apartmani 3★).

2. DAN – 23.08. MADRID – VALLADOLID
Doručak u churreriji (churros s toplom čokoladom). Jutarnja šetnja povijesnim centrom Madrida: Gran Vía, Plaza Mayor, Puerta del Sol, Royal Palace of Madrid (ulaznice uz doplatu). U poslijepodnevnim satima odlazak vlakom prema Valladolidu. Dolazak, transfer do smještaja, odmor i šetnja gradom.

BORAVAK U VALLADOLIDU I UČENJE JEZIKA
Od ponedjeljka započinje tečaj španjolskog u jezičnom institutu u centru grada. Polaznici u grupama prema razini (početnici, srednja razina, napredni). Nastava u manjim grupama; međunarodna skupina polaznika – druženje i praksa jezika.

VALLADOLID – kultura i gastronomija
Nekadašnja prijestolnica Španjolske; elegantni trgovi, studentski život. Poznat po lechazu, tapasima i vinima Ribera del Duero i Rueda.

IZLETI UKLJUČENI U CIJENU
• Segovia – UNESCO, rimski akvadukt, Alcázar, katedrala, cochinillo asado.
• Salamanca – jedno od najstarijih sveučilišta u Europi, Plaza Mayor, zlatni pješčenjak.

OPCIJSKI IZLETI (nisu uključeni u cijenu)
Ávila (zidine), León (katedrala, San Isidoro). Posjeti vinarijama u Ribera del Duero i Rueda – uz doplatu.

ZAŠTO UČITI U VALLADOLIDU
Čist kastiljski izgovor, autentična atmosfera, polaznici iz cijelog svijeta, bogata gastronomija, idealna baza za izlete.

💰 CIJENA ARANŽMANA: 1.790,00 € po osobi

✅ CIJENA UKLJUČUJE
Povratni let Zagreb – Madrid – Zagreb • Aerodromske pristojbe • Transfer aerodrom – smještaj • 1 noćenje u Madridu (apartmani 3★) • Vlak Madrid – Valladolid – Madrid • Smještaj u Valladolidu tijekom programa • Tečaj španjolskog u institutu u centru • Izlet u Segoviu • Izlet u Salamancu • Organizacija • Voditelj putovanja (hr/es) tijekom programa

❌ CIJENA NE UKLJUČUJE
Opcijske izlete (Ávila, León) • Posjete vinarijama • Osobne troškove • Putno osiguranje

📞 Rezervacije: info@linatravelina.eu | +385 91 214 447 7
TraveLina – putovanja koja se pamte!`,
    en: `VALLADOLID – SPANISH LANGUAGE PROGRAM
Intensive course, culture and authentic Spanish atmosphere

🗓 22–30 August 2026 | 9 days / 8 nights

This trip is designed for everyone who wants to learn or improve Spanish in an authentic setting. The programme combines an intensive course in Valladolid, discovering Spanish culture and gastronomy, and excursions to historic towns of Castile and León. A tour leader is available in Croatian and Spanish throughout the trip.

📍 TRAVEL PROGRAMME

DAY 1 – 22 AUG ZAGREB – MADRID
Meeting in the afternoon at Franjo Tuđman Airport. Direct evening flight Zagreb–Madrid. Late evening arrival, transfer to accommodation and overnight in Madrid (3★ apartments).

DAY 2 – 23 AUG MADRID – VALLADOLID
Breakfast at a churrería (churros with hot chocolate). Morning walk through Madrid's historic centre: Gran Vía, Plaza Mayor, Puerta del Sol, Royal Palace of Madrid (entrance tickets at extra cost). Afternoon train to Valladolid. Arrival, transfer to accommodation, rest and city walk.

STAY IN VALLADOLID AND LANGUAGE COURSE
From Monday, Spanish classes begin at a language institute in the city centre. Participants in level groups (beginners, intermediate, advanced). Small-group tuition; international group – socialising and language practice.

VALLADOLID – culture and gastronomy
Former capital of Spain; elegant squares and student life. Famous for lechazo, tapas and Ribera del Duero and Rueda wines.

EXCURSIONS INCLUDED IN THE PRICE
• Segovia – UNESCO, Roman aqueduct, Alcázar, cathedral, cochinillo asado.
• Salamanca – one of Europe's oldest universities, Plaza Mayor, golden sandstone.

OPTIONAL EXCURSIONS (not included)
Ávila (walls), León (cathedral, San Isidoro). Winery visits in Ribera del Duero and Rueda – supplement.

WHY LEARN IN VALLADOLID
Clear Castilian accent • authentic atmosphere • participants from around the world • rich gastronomy • ideal base for excursions

💰 PACKAGE PRICE: €1,790.00 per person

✅ PRICE INCLUDES
Return flight Zagreb–Madrid–Zagreb • Airport taxes • Airport–accommodation transfers • 1 night in Madrid (3★ apartments) • Train Madrid–Valladolid–Madrid • Accommodation in Valladolid during the programme • Spanish course at central institute • Segovia excursion • Salamanca excursion • Organisation • Tour leader (HR/ES) during the programme

❌ NOT INCLUDED
Optional excursions (Ávila, León) • Winery visits • Personal expenses • Travel insurance

📞 Bookings: info@linatravelina.eu | +385 91 214 447 7
TraveLina – trips you'll remember!`,
    de: `VALLADOLID – SPANISCHKURS
Intensivkurs, Kultur und authentische spanische Atmosphäre

🗓 22.–30. August 2026 | 9 Tage / 8 Nächte

Reise für alle, die Spanisch in authentischer Umgebung lernen oder verbessern möchten. Intensivkurs in Valladolid, spanische Kultur und Gastronomie, Ausflüge in historische Städte Kastiliens und Leóns. Reiseleitung auf Kroatisch und Spanisch.

📍 PROGRAMM

TAG 1 – 22.08. ZAGREB – MADRID
Treffen am Nachmittag am Flughafen Franjo Tuđman. Direktflug am Abend nach Madrid. Späte Ankunft, Transfer, Übernachtung in Madrid (3★-Apartments).

TAG 2 – 23.08. MADRID – VALLADOLID
Frühstück in der Churrería. Morgens Stadtrundgang: Gran Vía, Plaza Mayor, Puerta del Sol, Königspalast (Eintritt gegen Aufpreis). Nachmittags Zug nach Valladolid. Ankunft, Transfer, Erholung, Stadtbummel.

AUFENTHALT & SPRACHKURS
Ab Montag Spanischkurs im Sprachinstitut im Zentrum. Niveaugruppen (Anfänger, Mittelstufe, Fortgeschrittene). Kleine Gruppen; internationale Teilnehmer.

VALLADOLID – Kultur & Gastronomie
Ehemalige spanische Hauptstadt; elegante Plätze, Studentenleben. Lechazo, Tapas, Ribera del Duero & Rueda.

INKLUSIVE AUSFLÜGE
• Segovia – UNESCO, Aquädukt, Alcázar, Kathedrale, Cochinillo asado
• Salamanca – älteste Universitäten Europas, Plaza Mayor

OPTIONAL
Ávila, León, Weingüter – gegen Aufpreis

WARUM VALLADOLID
Klarer kastilischer Akzent • authentische Atmosphäre • internationale Gruppe • Gastronomie • ideale Ausgangsbasis

💰 PAKETPREIS: 1.790,00 € pro Person

✅ INKLUSIVE
Flug Zagreb–Madrid–Zagreb • Flughafengebühren • Transfers • 1 Nacht Madrid 3★ • Zug Madrid–Valladolid–Madrid • Unterkunft Valladolid • Kurs • Segovia & Salamanca • Organisation • Reiseleitung (KR/ES)

❌ NICHT INKLUSIVE
Optionale Ausflüge • Weingüter • persönliche Kosten • Versicherung

📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
    es: `VALLADOLID – CURSO DE ESPAÑOL
Curso intensivo, cultura y auténtica atmósfera española

🗓 22–30 agosto 2026 | 9 días / 8 noches

Viaje para quienes desean aprender o perfeccionar el español en un entorno auténtico. Combina curso intensivo en Valladolid, cultura y gastronomía españolas y excursiones a ciudades históricas de Castilla y León. Guía en croata y español.

📍 PROGRAMA

DÍA 1 – 22 ago ZAGREB – MADRID
Encuentro por la tarde en el aeropuerto Franjo Tuđman. Vuelo directo nocturno a Madrid. Llegada tarde, traslado y noche en Madrid (apartamentos 3★).

DÍA 2 – 23 ago MADRID – VALLADOLID
Desayuno en churrería (churros con chocolate caliente). Paseo matutino: Gran Vía, Plaza Mayor, Puerta del Sol, Palacio Real (entrada con suplemento). Tarde en tren a Valladolid. Llegada, traslado, descanso y paseo.

ESTANCIA Y CURSO
Desde el lunes, curso de español en instituto del centro. Grupos por nivel (principiantes, intermedio, avanzado). Grupos reducidos; alumnos internacionales.

VALLADOLID – cultura y gastronomía
Antigua capital de España; plazas elegantes, vida universitaria. Lechazo, tapas, vinos Ribera del Duero y Rueda.

EXCURSIONES INCLUIDAS
• Segovia – UNESCO, acueducto, Alcázar, catedral, cochinillo asado
• Salamanca – universidad histórica, Plaza Mayor

OPCIONALES
Ávila, León, bodegas – con suplemento

POR QUÉ VALLADOLID
Pronunciación castellana clara • ambiente auténtico • alumnos de todo el mundo • gastronomía • base ideal para excursiones

💰 PRECIO: 1.790,00 € por persona

✅ INCLUYE
Vuelo Zagreb–Madrid–Zagreb • Tasas • Traslados • 1 noche Madrid 3★ • Tren Madrid–Valladolid–Madrid • Alojamiento Valladolid • Curso • Segovia y Salamanca • Organización • Guía (HR/ES)

❌ NO INCLUYE
Excursiones opcionales • Bodegas • Gastos personales • Seguro

📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
  },

  "valladolid-2tjedan": {
    hr: `VALLADOLID – UČENJE ŠPANJOLSKOG JEZIKA
14 dana jezika, kulture i autentične španjolske atmosfere

🗓 22.08. – 05.09.2026. | 14 dana / 13 noći

Putovanje je namijenjeno svima koji žele učiti ili usavršiti španjolski u autentičnom okruženju. Program kombinira intenzivni tečaj u Valladolidu (dva radna tjedna), upoznavanje kulture i gastronomije te izlete u povijesne gradove Castille i Leóna. Voditelj putovanja na hrvatskom i španjolskom jeziku uz vas je tijekom cijelog programa.

📍 PROGRAM PUTOVANJA

1. DAN – 22.08. ZAGREB – MADRID
Sastanak putnika u poslijepodnevnim satima u zračnoj luci Franjo Tuđman. Direktan let Zagreb – Madrid u večernjim satima. Dolazak u kasnim večernjim satima, transfer do smještaja i noćenje u Madridu (apartmani 3★).

2. DAN – 23.08. MADRID – VALLADOLID
Doručak u jednoj od najstarijih churrerija (churros s toplom čokoladom). Jutarnja šetnja centrom: Gran Vía, Plaza Mayor, Puerta del Sol, Royal Palace of Madrid (ulaznice uz doplatu). U poslijepodnevnim satima vlakom u Valladolid. Dolazak, transfer do smještaja, odmor i šetnja gradom.

BORAVAK U VALLADOLIDU I UČENJE JEZIKA
Od ponedjeljka započinje tečaj španjolskog u jezičnom institutu u centru grada. Polaznici u grupama prema razini (početnici, srednja razina, napredni). Nastava u manjim grupama; međunarodna skupina – druženje i praksa jezika svakodnevno (polaznici od mlađih do starijih, iz cijelog svijeta).

Dva uzastopna radna tjedna učvršćuju jezik i komunikaciju u autentičnom okruženju. Izleti u Segoviu i Salamancu uključeni su tijekom boravka (prema rasporedu instituta i grupe).

ZAVRŠETAK I POVRATAK
Organiziran odlazak vlakom Valladolid – Madrid i povratni let Madrid – Zagreb u skladu s konačnim rasporedom prijevoza (često isti dan; do 05.09.2026.).

VALLADOLID – kultura i gastronomija
Nekadašnja prijestolnica Španjolske; elegantni trgovi, studentski život. Poznat po lechazu, tapasima i vinima Ribera del Duero i Rueda.

IZLETI UKLJUČENI U CIJENU
• Segovia – UNESCO, rimski akvadukt, Alcázar, katedrala, cochinillo asado.
• Salamanca – jedno od najstarijih sveučilišta u Europi, Plaza Mayor, zlatni pješčenjak.

OPCIJSKI IZLETI (nisu uključeni u cijenu)
Ávila (zidine), León (katedrala, San Isidoro). Posjeti vinarijama u Ribera del Duero i Rueda – uz doplatu.

ZAŠTO UČITI U VALLADOLIDU
Čist kastiljski izgovor • autentična atmosfera • polaznici iz cijelog svijeta • bogata gastronomija • idealna baza za izlete u Castillu

💰 CIJENA ARANŽMANA: 2.490,00 € po osobi

✅ CIJENA UKLJUČUJE
Povratni let Zagreb – Madrid – Zagreb • Aerodromske pristojbe • Transfer aerodrom – smještaj • 1 noćenje u Madridu (apartmani 3★) • Karta za vlak Madrid – Valladolid – Madrid • Smještaj u Valladolidu tijekom programa • Tečaj španjolskog u institutu u centru • Izlet u Segoviu • Izlet u Salamancu • Organizacija • Voditelj putovanja (hr/es) tijekom cijelog programa

❌ CIJENA NE UKLJUČUJE
Opcijske izlete (Ávila, León) • Posjete vinarijama • Osobne troškove • Putno osiguranje

📞 Rezervacije: info@linatravelina.eu | +385 91 214 447 7
TraveLina – putovanja koja se pamte!`,
    en: `VALLADOLID – SPANISH LANGUAGE PROGRAM (2 WEEKS)
14 days of language, culture and authentic Spanish atmosphere

🗓 22 August – 5 September 2026 | 14 days / 13 nights

For everyone who wants to learn or improve Spanish in an authentic setting. Two full teaching weeks in Valladolid, culture and gastronomy, excursions to Castile and León. Tour leader in Croatian and Spanish throughout the entire programme.

📍 TRAVEL PROGRAMME

DAY 1 – 22 AUG ZAGREB – MADRID
Afternoon meeting at Franjo Tuđman Airport. Direct evening flight to Madrid. Late arrival, transfer, overnight in Madrid (3★ apartments).

DAY 2 – 23 AUG MADRID – VALLADOLID
Breakfast at one of the oldest churrerías. Morning walk: Gran Vía, Plaza Mayor, Puerta del Sol, Royal Palace (tickets at extra cost). Afternoon train to Valladolid. Arrival, transfer, rest, city walk.

STAY AND LANGUAGE COURSE
From Monday, Spanish classes at a central language institute. Level groups (beginners, intermediate, advanced). Small groups; international participants of all ages – daily practice and socialising.

Two consecutive teaching weeks strengthen language and communication in an authentic environment. Segovia and Salamanca excursions included during the stay (per institute and group schedule).

END AND RETURN
Organised train Valladolid–Madrid and return flight Madrid–Zagreb per final transport schedule (often same day; by 5 Sep 2026).

VALLADOLID – culture and gastronomy
Former capital of Spain; elegant squares, student life. Lechazo, tapas, Ribera del Duero and Rueda wines.

EXCURSIONS INCLUDED
• Segovia – UNESCO, aqueduct, Alcázar, cathedral, cochinillo asado
• Salamanca – historic university, Plaza Mayor

OPTIONAL
Ávila, León, wineries – supplement

WHY VALLADOLID
Clear Castilian accent • authentic atmosphere • international group • gastronomy • ideal base for Castile

💰 PACKAGE PRICE: €2,490.00 per person

✅ INCLUDES
Return flight Zagreb–Madrid–Zagreb • Taxes • Transfers • 1 night Madrid 3★ • Train tickets Madrid–Valladolid–Madrid • Valladolid accommodation • Course • Segovia & Salamanca • Organisation • Tour leader (HR/ES) throughout

❌ NOT INCLUDED
Optional excursions • Wineries • Personal costs • Insurance

📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
    de: `VALLADOLID – SPANISCHKURS (2 WOCHEN)
14 Tage Sprache, Kultur und authentisches Spanien

🗓 22.08.–05.09.2026 | 14 Tage / 13 Nächte

Intensivkurs über zwei Unterrichtswochen in Valladolid, Kultur, Gastronomie, Ausflüge in Kastilien und León. Reiseleitung KR/ES während des gesamten Programms.

📍 PROGRAMM

TAG 1–2 wie beim 1-Wochen-Programm (22.–23.08. Madrid, Zug nach Valladolid).

AUFENTHALT & KURS
Ab Montag Spanisch im Institut, Niveaugruppen, kleine internationale Gruppen. Zwei Unterrichtswochen festigen Sprache und Kommunikation. Ausflüge Segovia & Salamanca inklusive.

RÜCKREISE
Organisierter Zug Valladolid–Madrid und Flug Madrid–Zagreb laut Plan (oft am selben Tag; bis 05.09.2026).

VALLADOLID, INKLUSIVE/OPTIONALE AUSFLÜGE – wie beim 1-Wochen-Programm.

💰 PAKETPREIS: 2.490,00 € pro Person

✅ INKLUSIVE
Flug Zagreb–Madrid–Zagreb • Gebühren • Transfers • 1 Nacht Madrid 3★ • Zugtickets • Unterkunft Valladolid • Kurs • Segovia & Salamanca • Organisation • Reiseleitung (KR/ES) während des gesamten Programms

❌ NICHT INKLUSIVE
Optionale Ausflüge • Weingüter • persönliche Kosten • Versicherung

📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
    es: `VALLADOLID – CURSO DE ESPAÑOL (2 SEMANAS)
14 días de idioma, cultura y atmósfera española auténtica

🗓 22 ago – 5 sep 2026 | 14 días / 13 noches

Curso intensivo de dos semanas lectivas en Valladolid, cultura, gastronomía y excursiones por Castilla y León. Guía en croata y español durante todo el programa.

📍 PROGRAMA

DÍAS 1–2 como en el programa de 1 semana (22–23 ago Madrid, tren a Valladolid).

ESTANCIA Y CURSO
Desde el lunes, español en instituto del centro, grupos por nivel, alumnos internacionales de todas las edades. Dos semanas lectivas consolidan el idioma. Excursiones a Segovia y Salamanca incluidas.

REGRESO
Tren Valladolid–Madrid y vuelo Madrid–Zagreb según horario final (a menudo el mismo día; hasta 5 sep 2026).

VALLADOLID, excursiones incluidas/opcionales – como en el programa de 1 semana.

💰 PRECIO: 2.490,00 € por persona

✅ INCLUYE
Vuelo Zagreb–Madrid–Zagreb • Tasas • Traslados • 1 noche Madrid 3★ • Billetes de tren • Alojamiento Valladolid • Curso • Segovia y Salamanca • Organización • Guía (HR/ES) durante todo el programa

❌ NO INCLUYE
Excursiones opcionales • Bodegas • Gastos personales • Seguro

📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
  },

  "valladolid-1tjedan-lipanj": {
    hr: `Valladolid učenje španjolskog jezika
Intenzivni tečaj jezika, kulture i autentične španjolske atmosfere

🗓 13.06. – 21.06.2026. | 9 dana / 8 noći

Putovanje je namijenjeno svima koji žele učiti ili usavršiti španjolski u autentičnom okruženju. Program kombinira intenzivni tečaj u Valladolidu, upoznavanje španjolske kulture i gastronomije te izlete u povijesne gradove Castille i Leóna. Tijekom putovanja sudionicima je na raspolaganju voditelj na hrvatskom i španjolskom jeziku.

📍 PROGRAM PUTOVANJA

1. DAN – 13.06. ZAGREB – MADRID
Sastanak putnika u poslijepodnevnim satima u zračnoj luci Franjo Tuđman. Direktan let Zagreb – Madrid u večernjim satima. Dolazak u kasnim večernjim satima, transfer do smještaja i noćenje u Madridu (apartmani 3★).

2. DAN – 14.06. MADRID – VALLADOLID
Doručak u churreriji (churros s toplom čokoladom). Jutarnja šetnja povijesnim centrom Madrida: Gran Vía, Plaza Mayor, Puerta del Sol, Royal Palace of Madrid (ulaznice uz doplatu). U poslijepodnevnim satima odlazak vlakom prema Valladolidu. Dolazak, transfer do smještaja, odmor i šetnja gradom.

BORAVAK U VALLADOLIDU I UČENJE JEZIKA
Od ponedjeljka 15.06. započinje tečaj španjolskog u jezičnom institutu u centru grada. Polaznici u grupama prema razini (početnici, srednja razina, napredni). Nastava u manjim grupama; međunarodna skupina polaznika – druženje i praksa jezika.

ZAVRŠETAK I POVRATAK
Organiziran povratni let Madrid – Zagreb u skladu s konačnim rasporedom prijevoza (21.06.2026.).

VALLADOLID – kultura i gastronomija
Nekadašnja prijestolnica Španjolske; elegantni trgovi, studentski život. Poznat po lechazu, tapasima i vinima Ribera del Duero i Rueda.

IZLETI UKLJUČENI U CIJENU
• Segovia – UNESCO, rimski akvadukt, Alcázar, katedrala, cochinillo asado.
• Salamanca – jedno od najstarijih sveučilišta u Europi, Plaza Mayor, zlatni pješčenjak.

OPCIJSKI IZLETI (nisu uključeni u cijenu)
Ávila (zidine), León (katedrala, San Isidoro). Posjeti vinarijama u Ribera del Duero i Rueda – uz doplatu.

ZAŠTO UČITI U VALLADOLIDU
Čist kastiljski izgovor, autentična atmosfera, polaznici iz cijelog svijeta, bogata gastronomija, idealna baza za izlete.

💰 Cijena aranžmana: 1.790,00 € po osobi

✅ CIJENA UKLJUČUJE
Povratni let Zagreb – Madrid – Zagreb • Aerodromske pristojbe • Transfer aerodrom – smještaj • 1 noćenje u Madridu (apartmani 3★) • Vlak Madrid – Valladolid – Madrid • Smještaj u Valladolidu tijekom programa • Tečaj španjolskog u institutu u centru • Izlet u Segoviu • Izlet u Salamancu • Organizacija • Voditelj putovanja (hr/es) tijekom programa

❌ CIJENA NE UKLJUČUJE
Opcijske izlete (Ávila, León) • Posjete vinarijama • Osobne troškove • Putno osiguranje

📞 Rezervacije: info@linatravelina.eu | +385 91 214 447 7
TraveLina – putovanja koja se pamte!`,
    en: `VALLADOLID – SPANISH LANGUAGE PROGRAM
Intensive course, culture and authentic Spanish atmosphere

🗓 13–21 June 2026 | 9 days / 8 nights

Learn or improve Spanish in Valladolid with Madrid start, train transfer, central language institute (level groups), included Segovia and Salamanca excursions. Tour leader in Croatian and Spanish.

📍 TRAVEL PROGRAMME

DAY 1 – 13 JUN ZAGREB – MADRID
Afternoon meeting at Franjo Tuđman Airport. Direct evening flight to Madrid. Late arrival, transfer, overnight in Madrid (3★ apartments).

DAY 2 – 14 JUN MADRID – VALLADOLID
Breakfast at a churrería. Morning walk: Gran Vía, Plaza Mayor, Puerta del Sol, Royal Palace (tickets at extra cost). Afternoon train to Valladolid. Arrival, transfer, rest, city walk.

STAY AND COURSE
From Monday 15 June, Spanish classes at the central institute. Level groups; small international groups – language practice and socialising.

END AND RETURN
Organised return flight Madrid–Zagreb per final schedule (21 June 2026).

VALLADOLID – culture and gastronomy, included Segovia & Salamanca, optional Ávila/León and wineries – as in our August programme.

WHY VALLADOLID
Clear Castilian accent • authentic atmosphere • international participants • gastronomy • ideal excursion base

💰 PACKAGE PRICE: €1,790.00 per person

✅ INCLUDES
Return flight Zagreb–Madrid–Zagreb • Taxes • Transfers • 1 night Madrid 3★ • Train Madrid–Valladolid–Madrid • Valladolid accommodation • Course • Segovia & Salamanca • Organisation • Tour leader (HR/ES)

❌ NOT INCLUDED
Optional excursions • Wineries • Personal costs • Insurance

📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
    de: `VALLADOLID – SPANISCHKURS
Intensivkurs, Kultur, authentisches Spanien

🗓 13.–21. Juni 2026 | 9 Tage / 8 Nächte

Spanisch lernen in Valladolid: Start in Madrid, Zug, Institut im Zentrum (Niveaugruppen), Ausflüge Segovia & Salamanca inklusive. Reiseleitung KR/ES.

📍 PROGRAMM

TAG 1 – 13.06. ZAGREB – MADRID | TAG 2 – 14.06. MADRID – VALLADOLID
Wie beim August-Programm (Churrería, Stadtrundgang Madrid, Zug nach Valladolid).

AUFENTHALT & KURS ab Montag 15.06. im Sprachinstitut. Rückflug Madrid–Zagreb am 21.06.2026.

VALLADOLID – Kultur, Gastronomie, inklusive/optionale Ausflüge wie beim August-Termin.

💰 PAKETPREIS: 1.790,00 € pro Person

✅ INKLUSIVE
Flug Zagreb–Madrid–Zagreb • Gebühren • Transfers • 1 Nacht Madrid 3★ • Zug • Unterkunft Valladolid • Kurs • Segovia & Salamanca • Organisation • Reiseleitung (KR/ES)

❌ NICHT INKLUSIVE
Optionale Ausflüge • Weingüter • persönliche Kosten • Versicherung

📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
    es: `VALLADOLID – CURSO DE ESPAÑOL
Curso intensivo, cultura y atmósfera auténtica

🗓 13–21 junio 2026 | 9 días / 8 noches

Aprende español en Valladolid: inicio en Madrid, tren, instituto central (grupos por nivel), excursiones a Segovia y Salamanca incluidas. Guía en croata y español.

📍 PROGRAMA

DÍA 1 – 13 jun ZAGREB – MADRID | DÍA 2 – 14 jun MADRID – VALLADOLID
Como en el programa de agosto (churrería, paseo por Madrid, tren a Valladolid).

ESTANCIA Y CURSO desde el lunes 15 jun en el instituto. Vuelo de regreso Madrid–Zagreb el 21 jun 2026.

VALLADOLID – cultura, gastronomía, excursiones incluidas/opcionales como en agosto.

💰 PRECIO: 1.790,00 € por persona

✅ INCLUYE
Vuelo Zagreb–Madrid–Zagreb • Tasas • Traslados • 1 noche Madrid 3★ • Tren • Alojamiento Valladolid • Curso • Segovia y Salamanca • Organización • Guía (HR/ES)

❌ NO INCLUYE
Excursiones opcionales • Bodegas • Gastos personales • Seguro

📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
  },

  "valladolid-2tjedan-lipanj": {
    hr: `Valladolid učenje španjolskog jezika
14 dana jezika, kulture i autentične španjolske atmosfere

🗓 13.06. – 27.06.2026. | 14 dana / 13 noći

Putovanje je namijenjeno svima koji žele učiti ili usavršiti španjolski u autentičnom okruženju. Program kombinira intenzivni tečaj u Valladolidu (dva radna tjedna), upoznavanje kulture i gastronomije te izlete u povijesne gradove Castille i Leóna. Voditelj putovanja na hrvatskom i španjolskom jeziku uz vas je tijekom cijelog programa.

📍 PROGRAM PUTOVANJA

1. DAN – 13.06. ZAGREB – MADRID
Sastanak putnika u poslijepodnevnim satima u zračnoj luci Franjo Tuđman. Direktan let Zagreb – Madrid u večernjim satima. Dolazak u kasnim večernjim satima, transfer do smještaja i noćenje u Madridu (apartmani 3★).

2. DAN – 14.06. MADRID – VALLADOLID
Doručak u jednoj od najstarijih churrerija (churros s toplom čokoladom). Jutarnja šetnja centrom: Gran Vía, Plaza Mayor, Puerta del Sol, Royal Palace of Madrid (ulaznice uz doplatu). U poslijepodnevnim satima vlakom u Valladolid. Dolazak, transfer do smještaja, odmor i šetnja gradom.

BORAVAK U VALLADOLIDU I UČENJE JEZIKA
Od ponedjeljka 15.06. započinje tečaj španjolskog u jezičnom institutu u centru grada. Polaznici u grupama prema razini (početnici, srednja razina, napredni). Nastava u manjim grupama; međunarodna skupina – druženje i praksa jezika svakodnevno (polaznici od mlađih do starijih, iz cijelog svijeta).

Dva uzastopna radna tjedna učvršćuju jezik i komunikaciju u autentičnom okruženju. Izleti u Segoviu i Salamancu uključeni su tijekom boravka (prema rasporedu instituta i grupe).

ZAVRŠETAK I POVRATAK
Organiziran odlazak vlakom Valladolid – Madrid i povratni let Madrid – Zagreb u skladu s konačnim rasporedom prijevoza (do 27.06.2026.).

VALLADOLID – kultura i gastronomija
Nekadašnja prijestolnica Španjolske; elegantni trgovi, studentski život. Poznat po lechazu, tapasima i vinima Ribera del Duero i Rueda.

IZLETI UKLJUČENI U CIJENU
• Segovia – UNESCO, rimski akvadukt, Alcázar, katedrala, cochinillo asado.
• Salamanca – jedno od najstarijih sveučilišta u Europi, Plaza Mayor, zlatni pješčenjak.

OPCIJSKI IZLETI (nisu uključeni u cijenu)
Ávila (zidine), León (katedrala, San Isidoro). Posjeti vinarijama u Ribera del Duero i Rueda – uz doplatu.

ZAŠTO UČITI U VALLADOLIDU
Čist kastiljski izgovor • autentična atmosfera • polaznici iz cijelog svijeta • bogata gastronomija • idealna baza za izlete u Castillu

💰 Cijena aranžmana (dva tjedna): 2.490,00 € po osobi

✅ CIJENA UKLJUČUJE
Povratni let Zagreb – Madrid – Zagreb • Aerodromske pristojbe • Transfer aerodrom – smještaj • 1 noćenje u Madridu (apartmani 3★) • Karta za vlak Madrid – Valladolid – Madrid • Smještaj u Valladolidu tijekom programa • Tečaj španjolskog u institutu u centru • Izlet u Segoviu • Izlet u Salamancu • Organizacija • Voditelj putovanja (hr/es) tijekom cijelog programa

❌ CIJENA NE UKLJUČUJE
Opcijske izlete (Ávila, León) • Posjete vinarijama • Osobne troškove • Putno osiguranje

📞 Rezervacije: info@linatravelina.eu | +385 91 214 447 7
TraveLina – putovanja koja se pamte!`,
    en: `VALLADOLID – SPANISH LANGUAGE PROGRAM (2 WEEKS)
14 days of language, culture and authentic Spanish atmosphere

🗓 13–27 June 2026 | 14 days / 13 nights

Two teaching weeks of intensive Spanish in Valladolid, Madrid start, train transfer, central institute, Segovia and Salamanca included. Tour leader in Croatian and Spanish throughout.

📍 TRAVEL PROGRAMME

DAY 1 – 13 JUN ZAGREB – MADRID | DAY 2 – 14 JUN MADRID – VALLADOLID
As in the August programme (churrería, Madrid walk, train to Valladolid).

STAY AND COURSE from Monday 15 June at the language institute. Two teaching weeks; daily practice in an international group. Segovia and Salamanca included.

END AND RETURN
Train Valladolid–Madrid and return flight Madrid–Zagreb per schedule (by 27 June 2026).

VALLADOLID – culture, gastronomy, included and optional excursions as in the August two-week programme.

💰 PACKAGE PRICE: €2,490.00 per person

✅ INCLUDES
Return flight Zagreb–Madrid–Zagreb • Taxes • Transfers • 1 night Madrid 3★ • Train tickets • Valladolid accommodation • Course • Segovia & Salamanca • Organisation • Tour leader (HR/ES) throughout

❌ NOT INCLUDED
Optional excursions • Wineries • Personal costs • Insurance

📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
    de: `VALLADOLID – SPANISCHKURS (2 WOCHEN)
14 Tage Sprache, Kultur, authentisches Spanien

🗓 13.–27. Juni 2026 | 14 Tage / 13 Nächte

Zwei Unterrichtswochen Intensivkurs in Valladolid, Start Madrid, Zug, Institut ab 15.06., Ausflüge Segovia & Salamanca inkl. Reiseleitung KR/ES während des gesamten Programms.

Rückreise: Zug Valladolid–Madrid und Flug Madrid–Zagreb bis 27.06.2026.

💰 PAKETPREIS: 2.490,00 € pro Person

✅ INKLUSIVE
Flug Zagreb–Madrid–Zagreb • Gebühren • Transfers • 1 Nacht Madrid 3★ • Zugtickets • Unterkunft Valladolid • Kurs • Segovia & Salamanca • Organisation • Reiseleitung (KR/ES)

❌ NICHT INKLUSIVE
Optionale Ausflüge • Weingüter • persönliche Kosten • Versicherung

📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
    es: `VALLADOLID – CURSO DE ESPAÑOL (2 SEMANAS)
14 días de idioma, cultura y atmósfera auténtica

🗓 13–27 junio 2026 | 14 días / 13 noches

Dos semanas lectivas de español intensivo en Valladolid, inicio en Madrid, tren, instituto desde el 15 jun, excursiones Segovia y Salamanca incluidas. Guía HR/ES durante todo el programa.

Regreso: tren Valladolid–Madrid y vuelo Madrid–Zagreb hasta el 27 jun 2026.

💰 PRECIO: 2.490,00 € por persona

✅ INCLUYE
Vuelo Zagreb–Madrid–Zagreb • Tasas • Traslados • 1 noche Madrid 3★ • Tren • Alojamiento Valladolid • Curso • Segovia y Salamanca • Organización • Guía (HR/ES)

❌ NO INCLUYE
Excursiones opcionales • Bodegas • Gastos personales • Seguro

📞 info@linatravelina.eu | +385 91 214 447 7 | TraveLina`,
  },
};

export function ensureValladolidTourTranslations(tours) {
  if (!Array.isArray(tours)) return tours;
  return tours.map((tour) => {
    if (!tour?.key || !VALLADOLID_KEYS.includes(tour.key)) return tour;
    const pack = VALLADOLID_TOUR_DETAILED_INFO[tour.key];
    if (!pack) return tour;
    return {
      ...tour,
      detailedInfo: {
        hr: pack.hr,
        en: pack.en,
        de: pack.de,
        es: pack.es,
      },
    };
  });
}
